<template lang="pug">
  ul.utility-nav
    li.utility-nav__link
      cart-link

</template>
<script>
  import Icon from 'scripts/components/basic/Icon.vue';
  import BaseButton from 'scripts/components/buttons/BaseButton.vue';
  import HeaderSearch from 'scripts/components/site-header/HeaderSearch.vue';
  import CartLink from 'scripts/components/site-header/CartLink.vue';

  export default {
    name: 'UtilityNav',
    components: {
      Icon,
      BaseButton,
      HeaderSearch,
      CartLink,
    },
    props: {
      loggedIn: {
        type: Boolean,
        default: false,
      },
      suggestedSearches: {
        type: Array,
        default: () => [],
      },
      productImageBackgroundColor: String,
    },
    computed: {
      userLink() {
        return this.loggedIn ? '/account' : '/account/login';
      },
      userLabel() {
        return this.loggedIn ? 'My Account' : 'Log In';
      },
    },
  };
</script>
